/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-03-12 16:09:56
 * @modify date 2020-03-12 16:09:56
 * @desc [description]
 */
 <template>
  <div class="content-wrappper">
    <div class="row notification-container">
      <div class="row">
        <div class="col-xs-8 col-sm-7 col-md-4 mt-5">
          <router-link class="sub-heading" to="/layout/launchpad">
            <i class="fa fa-angle-left"></i>System Notifications List
          </router-link>
        </div>
        <div class="col-xs-4 col-sm-5 col-md-4 add-btn-container">
          <a
            href="javascript:void(0);"
            class="btn emergo-green-button add-btn"
            @click.prevent="openSystemNotification"
          >
            <span class="glyphicon glyphicon-plus cursor-pointer"></span> Add
            <span class="hidden-xs">New Notification</span>
          </a>
        </div>
        <div class="col-xs-12 mt-30">
          <div class="col-xs-12 p-0">
            <table class="table" v-if="notificationsList" id="notificationDataList">
              <thead>
                <tr>
                  <th class="wd_edit"></th>
                  <th class="wd_type">Type</th>
                  <th class="hidden-xs wd_start">Start Date and Time (CST)</th>
                  <th class="hidden-xs wd_end">End Date and Time (CST)</th>
                  <th class="wd_header">Header</th>
                  <th class="wd_message">Message</th>
                </tr>
              </thead>
              <tbody v-if="notificationsList && notificationsList.length">
                <tr v-for="(notification,index) in notificationsList" :key="index">
                  <td class="center wd_edit">
                    <span
                      class="glyphicon glyphicon-pencil cursor-pointer icon edit_color"
                      v-if="showIcon(notification.end_date)"
                      @click="editNotification(notification)"
                    ></span>
                  </td>
                  <td class="wd_type">{{getBannerTypeName(notification.banner_type_id)}}</td>
                  <td class="wd_start hidden-xs">{{notification.start_date | date}}</td>
                  <td class="wd_end hidden-xs">{{notification.end_date | date}}</td>
                  <td class="wd_header notification-description-ellipsis">{{notification.header}}</td>
                  <td class="wd_message notification-description-ellipsis">{{notification.message}}</td>
                </tr>
              </tbody>
            </table>
            <h2
              class="center"
              v-if="getAllSuccess && !notificationsList.length"
            >No notification(s) found</h2>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import moment from 'moment';
import {
  getBannerTypes,
  getAllNotifications,
} from '../../apis/systemNotifications';
import Loader from '../UIComponents/Loader.vue';

export default {
  data() {
    return {
      notificationsList: [],
      bannerTypes: [],
      loaderStatus: false,
      getAllSuccess: false,
      CSTFormat: 'YYYY-MM-DD hh:mm A',
      timeZone: process.env.VUE_APP_CST_TIMEZONE,
      UTCFormat: 'YYYY-MM-DD HH:mm:ss',
    };
  },
  components: {
    Loader,
  },
  methods: {
    getBannerTypeName(id) {
      return this.bannerTypes.find((banner) => banner.id === id).type;
    },
    editNotification(notification) {
      localStorage.setItem('editobject', JSON.stringify(notification));
      this.$router.push({
        name: 'SystemNotifications',
        params: { editNotification: notification, notificationsList: this.notificationsList },
      });
    },
    showIcon(endDate) {
      return (
        moment()
          .utcOffset(this.timeZone)
          .format(this.UTCFormat)
        < moment(endDate, this.CSTFormat).format(this.UTCFormat)
      );
    },
    openSystemNotification() {
      localStorage.removeItem('editobject');
      this.$router.push({
        name: 'SystemNotifications',
        params: { notificationsList: this.notificationsList },
      });
    },
  },
  async created() {
    this.loaderStatus = true;
    this.bannerTypes = await getBannerTypes();
    const notificationsList = await getAllNotifications();
    this.getAllSuccess = true;
    notificationsList.forEach((each) => {
      const notification = each;
      notification.start_date = moment
        .utc(notification.start_date)
        .utcOffset(this.timeZone)
        .format(this.CSTFormat);
      notification.end_date = moment
        .utc(notification.end_date)
        .utcOffset(this.timeZone)
        .format(this.CSTFormat);
      this.notificationsList.push(notification);
    });
    this.loaderStatus = false;
  },
  filters: {
    date(inputDate) {
      return moment(inputDate, 'YYYY-MM-DD hh:mm A').format('LLLL');
    },
  },
};
</script>
<style scoped>
.table>tbody>tr>td {
  word-break: unset;
  word-wrap: normal;
}
.notification-container {
  margin: 20px 25px;
}
.sub-heading > i {
  margin-right: 6px;
}
.p-0 {
  padding: 0;
}
.sub-heading {
  font-family: Roboto;
  font-style: normal;
  font-size: 18px;
  color: #0b3c61;
  cursor: pointer;
}
.mt-30 {
  margin-top: 30px;
}
.mt-5 {
  margin-top: 5px;
}
.notification-container .table > thead > tr > th {
  background: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  padding: 12px;
  color: #0b3c61;
  border-bottom: 1px dashed #ebeef5 !important;
}
.notification-container .table > tbody > tr > td {
  padding: 12px !important;
  border-bottom: 1px solid #ebeef5 !important;
  font-size: 14px;
  line-height: 16px;
}
.icon {
  padding: 0 5px;
}
.icon.edit_color {
  color: #0b3c61;
  font-size: 16px;
}
.center {
  text-align: center;
}
.add-btn {
  min-width: 90px;
}
.notification-description-ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
#notificationDataList tbody > tr:hover {
  background-color: rgba(103, 177, 226, 0.35);
}
#notificationDataList tr:nth-of-type(even) {
  background: rgba(103, 177, 226, 0.2);
}
#notificationDataList thead, #notificationDataList tbody, #notificationDataList tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.table>thead{
  border-top: 1px solid #dfe5e9;
  border-bottom: 2px solid #dfe5e9;
}
.table>thead:first-child>tr:first-child>th{
  background-color: #fafafa !important;
}
.table>thead:first-child>tr:first-child>th:hover{
  background-color: #dfe5e9 !important;
}
.wd_edit{
  width: 5%;
}
.wd_type{
  width: 15%;
}
.wd_start{
  width: 25%;
}
.wd_end{
  width: 25%;
}
.wd_header{
  width: 20%;
}
.wd_message{
  width: 22%;
}
@media screen and (max-width: 767px) {
  .wd_edit{
    width: 10%;
  }
  .wd_type{
    width: 30%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .wd_header{
    width: 30%;
  }
  .wd_message{
    width: 30%;
  }
}
</style>
